
export function appendUserRoles(data) {
  data.Items = data.map((item) => {
    return { ...item };
  });
  return data;
}
